/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

interface UiTableSkeletonRowProps {
    colSpan: number
    className?: string
}

const UiTableSkeletonRow: React.FC<UiTableSkeletonRowProps> = ({
    colSpan,
    className,
}) => {
    return (
        <tr className={clsx('UiTableSkeletonRow')}>
            <td colSpan={colSpan} className={clsx('px-4 py-2', className)}>
                <div
                    className={clsx(
                        'w-full h-8 rounded-md bg-gray-100 dark:bg-gray-800 animate-pulse'
                    )}
                />
            </td>
        </tr>
    )
}

export default UiTableSkeletonRow
